import { actionColumn } from "@/components/Table/table.interface";
import { MODULES } from "@/constants";
// `channel` and `thumbnail` render an icon and an image rather than text, so they
// opt out of ellipsis truncation — clipping would cut the artwork off instead.
//
// `wrap` marks the columns holding a name rather than a value: under the Full
// view those spend overflow on height, capped at three lines, instead of hiding
// it. Only names — a 110px Size or Type column would break mid-word. `grow`
// sends the table's leftover width to the primary name column, which is one
// fewer wrapped line there and keeps it off the pinned action column.
const ListGroupedColumns = [
  { id: "name", label: "Name", width: 320, wrap: true, grow: true },
  { id: "channel", label: "Channel", width: 110, noTruncate: true },
  // The field is `variants`; the column id is `variant`. That one letter is why
  // it was `noSort` — the comparator read `row["variant"]`, found nothing on any
  // row, and left the order alone.
  { id: "variant", label: "Variants", sortKey: "variants", width: 120 },
  // Stays `noSort`: the cell is an image, so there is nothing to order by.
  {
    id: "thumbnail",
    label: "Thumbnail",
    noSort: true,
    width: 140,
    noTruncate: true,
  },
  actionColumn({ module: MODULES.CREATIVES, actions: ["update", "delete"] }),
];

// The flat creative list's columns live in ListAsset/listData.ts: Size and Type
// are derived from a JSON-string `assetInfo`, and Type additionally needs the
// channel, so the array has to be built next to the accessors that resolve them.
const DetailListColumns = [
  {
    id: "creative",
    label: "Creative Name",
    width: 300,
    wrap: true,
    grow: true,
  },
  { id: "lineItemName", label: "Line Item Name", width: 300, wrap: true },
  { id: "utmName", label: "Utm Name", width: 260, wrap: true },
  { id: "active", label: "Active", width: 120 },
];
const ASSET_TYPES = {
  BANNER: "banner",
  VIDEO: "video",
  NATIVE: "native",
};
export { ListGroupedColumns, DetailListColumns, ASSET_TYPES };
